import React from 'react';
import { parse, type CsvError } from 'csv-parse/browser/esm';
import translate from '@/lib/intl/translate';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line no-restricted-imports
import convertCsvFilesToUtf8 from '@/modules/Settings/utils/convertCsvFilesToUtf8';
import type { FileUploadItem } from '../fileUploader';
import UploadContexts from '../lib/UploadContexts';
import FileUploader from './FileUploader';

type BulkImportUploaderProps = {
  className?: string;
  onChange: (event: FileUploadItem[]) => void;
  onError: (event: unknown, item?: FileUploadItem) => void;
  onUploadFinished: (event: FileUploadItem[]) => void;
};

function BulkImportUploader({
  className = '',
  onChange,
  onError,
  onUploadFinished,
}: BulkImportUploaderProps) {
  const validate = async ([file]: File[]): Promise<Error | true> => {
    if (file.type !== 'text/csv') {
      return Promise.reject(
        new Error(translate('DATA_UPLOADS_FILE_UPLOAD_WRONG_TYPE')),
      );
    }

    if (file.size > 500000000) {
      return Promise.reject(
        new Error(translate('DATA_UPLOADS_FILE_UPLOAD_TOO_LARGE')),
      );
    }

    const csv = await file.text();

    return new Promise((resolve, reject) => {
      parse(csv, {}, (err: CsvError | undefined) => {
        if (err) {
          // eslint-disable-next-line no-console
          console.error(err.message);
          reject(
            new Error(translate('DATA_UPLOADS_FILE_UPLOAD_PROCESSING_ERROR')),
          );
        } else {
          resolve(true);
        }
      });
    });
  };

  return (
    <FileUploader
      accept="text/csv"
      className={className}
      context={UploadContexts.IMPORTS}
      onChange={onChange}
      onError={onError}
      onUploadFinished={onUploadFinished}
      preprocess={convertCsvFilesToUtf8}
      validate={validate}
    >
      <div className="w-full border-t border-grey-600 pt-4 text-center">
        {translate('DATA_UPLOADS_FILE_UPLOAD_INSTRUCTIONS')}
      </div>
    </FileUploader>
  );
}

export default BulkImportUploader;
